module.exports = __webpack_public_path__ + "static/media/checkDocumentsExpiringIcon.eda747a9.svg";